<template>
    <div>
        <Modal v-if="visible" :modelValue="visible"
               contentWidth="800px"
               :visible="visible" :title="'修改用户'" :showFooter="false" :overlayOpacity="0.5" @update:visible="visible = $event">
            <form>
                <div class="formDiv">
                    <InputField labelWidth="40%" style="margin: 0.5rem 0.2rem;width:45%" label="资产编号" type="text" id="code"
                                :modelValue="formData.code" required placeholder="资产编号" disabled
                                @update:modelValue="(value) => handleModelValueUpdate('code', value)"/>
                    <InputField labelWidth="40%" style="margin: 0.5rem 0.2rem;width:45%" label="资产名称" type="text" id="name"
                                :modelValue="formData.name" required placeholder="资产名称"
                                @update:modelValue="(value) => handleModelValueUpdate('name', value)"/>
                </div>
                <div class="formDiv">
                    <InputField labelWidth="40%" style="margin: 0.5rem 0.2rem;width:45%" label="品牌" type="text" id="brand"
                                :modelValue="formData.brand" placeholder="品牌"
                                @update:modelValue="(value) => handleModelValueUpdate('brand', value)"/>

                    <InputField labelWidth="40%" style="margin: 0.5rem 0.2rem;width:45%" label="规格型号" type="text" id="specification"
                                :modelValue="formData.specification" placeholder="规格型号"
                                @update:modelValue="(value) => handleModelValueUpdate('specification', value)"/>
                </div>
                <div class="formDiv">
                    <InputField labelWidth="40%" style="margin: 0.5rem 0.2rem;width:45%" label="单位" type="text" id="unit"
                                :modelValue="formData.unit" placeholder="单位"
                                @update:modelValue="(value) => handleModelValueUpdate('unit', value)"/>

                    <InputField labelWidth="40%" style="margin: 0.5rem 0.2rem;width:45%" label="单价(元)" type="text" id="price"
                                :modelValue="formData.price" required placeholder="单价(元)"
                                @update:modelValue="(value) => handleModelValueUpdate('price', value)"/>
                </div>
                <div class="formDiv">
                    <InputField labelWidth="40%" style="margin: 0.5rem 0.2rem;width:45%" label="数量" type="number" id="number"
                                :modelValue="formData.number" placeholder="数量"
                                @update:modelValue="(value) => handleModelValueUpdate('number', value)"/>

                    <SelectField labelWidth="40%" label="保管员" style="margin: 0.5rem 0.2rem;width:45%" id="chargerId"
                                 :modelValue="formData.chargerId" :options="userList" required
                                 @update:modelValue="(value) => handleModelValueUpdate('chargerId', value)"/>
                </div>
                <div class="formButton">
                    <a-space>
                        <ButtonField text="关闭" @click="cancel" secondary />
                        <ButtonField text="保存" primary @click="handleSubmit"/>
                    </a-space>
                </div>
            </form>
        </Modal>
    </div>
</template>

<script>
import { edit } from "../api/list";
import { mapState } from "vuex";
import Modal from '@/components/water-affairs-style/modal.vue';

export default {
    components: {Modal},
    data() {
        return {
            formData: {
                name: '',
                brand: '',
                specification: '',
                unit: '',
                price: '',
                number: '',
                chargerId: null
            },
            detail: {},
            loading: false,
            visible: true,
        };
    },
    pops:{
        visible: {
            type: Boolean,
            default: true
        },
    },
    computed: {
        ...mapState("userSelector", ["userList"]),
    },
    watch: {
        formData: {
            deep: true,
            handler(newVal) {
                this.formData = this.detail
                console.log("form changed:", newVal);
            },
        },
        visible: {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    const str = window.localStorage.getItem("materialDetail");
                    if (str) {
                        this.detail = JSON.parse(str);
                        this.formData = {
                            ...this.detail,
                            chargerId: this.getChargerId(this.detail.charger),
                        };
                        console.log("Initialized form data:", this.formData);
                    }
                }
            },
        },
    },
    mounted() {
        const str = window.localStorage.getItem("materialDetail");
        if (str) {
            this.detail = JSON.parse(str);
            this.detail = {
                ...this.detail,
                chargerId: this.getChargerId(this.detail.charger)
            };
            console.log("Initialized form data:", this.formData);
        }
    },

    methods: {
        handleModelValueUpdate(fieldName, value) {
            this.form[fieldName] = value;
        },
        // 根据保管员姓名查找ID
        getChargerId(chargerName) {
            console.log("chargerName:",chargerName)
            const user = this.userList.find(item => item.name === chargerName);
            console.log("user:",user)
            return user ? user.id : null;
        },

        handleSubmit() {
            if (this.isSubmitting) return;
            this.isSubmitting = true;
            if (!this.formData.name) {
                this.$message.error('任务名称不能为空');
                this.isSubmitting = false; // 重置标志
                return;
            }
            if (!this.formData.price) {
                this.$message.error('单价不能为空');
                this.isSubmitting = false;
                return;
            }
            if (!this.formData.chargerId) {
                this.$message.error('保管员不能为空');
                this.isSubmitting = false;
                return;
            }

            // 构建提交数据
            const submitData = {
                id: this.detail.id,
                ...this.formData,
                charger: this.userList.find(item => item.id === this.formData.chargerId)?.name || ''
            };


            edit(submitData).then(() => {
                    this.cancel();
                })
                .finally(() => {
                    this.isSubmitting = false;
                });
        },

        cancel() {
            this.visible = false;
            this.$emit('closed');
        },
    },
};
</script>

<style scoped>
.formDiv{
    display: flex;
    justify-content: space-between;
}
.formButton{
    margin-top: 1rem;
    width:100%;
    text-align: center;
}
</style>